module.exports = __webpack_public_path__ + "static/img/1.475a30a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/card/2/1.png
// module id = GfUr
// module chunks = 1